import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { updateMetaTags } from '../utils/seo';
import Translate from '../components/Translate';
import PageBanner from '../components/PageBanner';

const SpeechRecognition = () => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        updateMetaTags(
            `${t('speech_recognition_support')} | ${t('site-title')}`,
            t('speech_recognition_desc'),
            "speech recognition, nuance dragon, windows speech recognition, accessibility"
        );
    }, [t, i18n.language]);

    const softwares = [
        {
            name: t('software-dragon-name'),
            website: "https://www.nuance.com/dragon.html",
            type: t('type-commercial'),
        },
        {
            name: t('software-windows-name'),
            website: "https://support.microsoft.com/en-us/windows/use-voice-recognition-in-windows-83ff75be-dc47-975f-202d-625d996773f3",
            type: t('type-free-builtin'),
        }
    ];

    return (
        <section className="w-full min-h-screen bg-primary-50/30 pb-16 text-left">
            <PageBanner
                title={<Translate text={'speech_recognition_support'} />}
                subtitle={<Translate text={'speech_recognition-subtitle'} />}
                badgeText={t('badge-accessibility-support')}
            />
            <div className="max-w-5xl mx-auto px-4 py-12 sm:px-6 lg:px-8 mt-12">
                <div className="bg-white rounded-[24px] shadow-sm border border-[#dadce0] overflow-hidden">
                    <div className="p-8 border-b border-gray-100 bg-gray-50/30">
                        <p className="text-gray-700 leading-relaxed text-sm">
                            {t('speech_recognition_desc')}
                        </p>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50/50">
                                <tr>
                                    <th scope="col" className="px-8 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider">{t('software')}</th>
                                    <th scope="col" className="px-8 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider">{t('website')}</th>
                                    <th scope="col" className="px-8 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider">{t('free-commercial')}</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-100">
                                {softwares.map((software, idx) => (
                                    <tr key={idx} className="hover:bg-primary-50/20 transition-colors">
                                        <td className="px-8 py-5 whitespace-nowrap text-sm font-bold text-gray-800">
                                            {software.name}
                                        </td>
                                        <td className="px-8 py-5 text-sm text-blue-600">
                                            <a href={software.website} target="_blank" rel="noopener noreferrer" className="hover:underline font-medium inline-flex items-center gap-1">
                                                {software.website}
                                                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                                </svg>
                                            </a>
                                        </td>
                                        <td className="px-8 py-5 whitespace-nowrap text-sm text-gray-600">
                                            {software.type}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SpeechRecognition;
